import React, { useEffect, useState } from 'react';
import { Award, Check, ChevronRight, Crown, Diamond, Gift, Lock, Play, Sparkles, Star, Unlock, Zap, Clock, Users, Heart, MessageCircle, Bell, Shield, Calendar, RefreshCw, Gem, Layers, Package, Rocket, HelpCircle, CreditCard } from 'lucide-react';
import { EnhancedSpinWheel } from './EnhancedSpinWheel';
interface MembershipSectionProps {
  onBack?: () => void;
}
export const MembershipSection: React.FC<MembershipSectionProps> = ({
  onBack
}) => {
  const [selectedTier, setSelectedTier] = useState<'free' | 'silver' | 'gold' | 'platinum'>('silver');
  const [showSpinWheel, setShowSpinWheel] = useState(false);
  const [showFlashOffer, setShowFlashOffer] = useState(true);
  const [countdown, setCountdown] = useState({
    hours: 47,
    minutes: 59,
    seconds: 59
  });
  const [showUpgradeSuccess, setShowUpgradeSuccess] = useState(false);
  // User tokens for the spin wheel
  const userTokens = {
    loveTokens: 240,
    desireGems: 120
  };
  // Current user tier info
  const currentTier = {
    name: 'Silver',
    expiresIn: 28,
    progress: 65,
    tokensToNextTier: 150,
    nextTier: 'Gold'
  };
  // Simulate countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          clearInterval(timer);
          setShowFlashOffer(false);
          return prev;
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handleSpinWheel = () => {
    setShowSpinWheel(true);
  };
  const handleCloseSpinWheel = () => {
    setShowSpinWheel(false);
  };
  const handleRewardClaimed = (reward: any) => {
    console.log('Claimed reward:', reward);
    // Handle reward claiming logic
    setShowSpinWheel(false);
  };
  const handleUpgrade = (tier: 'silver' | 'gold' | 'platinum') => {
    setSelectedTier(tier);
    setShowUpgradeSuccess(true);
    // Hide success message after 3 seconds
    setTimeout(() => {
      setShowUpgradeSuccess(false);
    }, 3000);
  };
  return <div className="w-full max-w-4xl mx-auto" data-id="element-9533">
      {/* Hero Banner */}
      <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 p-6 mb-6 shadow-lg" data-id="element-9534">
        <div className="absolute inset-0 bg-grid-white/10 bg-[size:20px_20px] opacity-20" data-id="element-9535"></div>
        <div className="absolute -inset-40 bg-gradient-to-r from-purple-500/30 via-pink-500/30 to-blue-500/30 blur-3xl animate-pulse-slow" data-id="element-9536"></div>
        <div className="relative z-10" data-id="element-9537">
          <div className="flex items-center gap-3 mb-4" data-id="element-9538">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-full" data-id="element-9539">
              <Award size={24} className="text-white" data-id="element-9540" />
            </div>
            <div data-id="element-9541">
              <h1 className="text-2xl font-bold text-white" data-id="element-9542">
                VIP {currentTier.name} Member
              </h1>
              <div className="flex items-center gap-2 text-white/80" data-id="element-9543">
                <Clock size={14} data-id="element-9544" />
                <span data-id="element-9545">Expires in {currentTier.expiresIn} days</span>
              </div>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-4 mb-4" data-id="element-9546">
            <div className="flex justify-between items-center mb-2" data-id="element-9547">
              <span className="text-white/90 font-medium" data-id="element-9548">
                Progress to {currentTier.nextTier}
              </span>
              <span className="text-white/90 font-medium" data-id="element-9549">
                {currentTier.progress}%
              </span>
            </div>
            <div className="h-2.5 bg-white/20 rounded-full overflow-hidden" data-id="element-9550">
              <div className="h-full bg-gradient-to-r from-yellow-400 to-yellow-300 rounded-full transition-all duration-1000 ease-out" style={{
              width: `${currentTier.progress}%`
            }} data-id="element-9551"></div>
            </div>
            <p className="mt-2 text-white/80 text-sm" data-id="element-9552">
              Only {currentTier.tokensToNextTier} LuvTokens away from{' '}
              {currentTier.nextTier}! Upgrade now for premium benefits.
            </p>
          </div>
          <div className="flex items-center justify-between" data-id="element-9553">
            <div className="flex items-center gap-2" data-id="element-9554">
              <div className="w-8 h-8 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-full" data-id="element-9555">
                <Diamond size={16} className="text-white" data-id="element-9556" />
              </div>
              <div className="text-white" data-id="element-9557">
                <span className="font-bold" data-id="element-9558">240</span> LuvTokens
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-9559">
              <div className="w-8 h-8 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-full" data-id="element-9560">
                <Gem size={16} className="text-white" data-id="element-9561" />
              </div>
              <div className="text-white" data-id="element-9562">
                <span className="font-bold" data-id="element-9563">15</span> DesireGems
              </div>
            </div>
            <button className="px-3 py-1.5 bg-white/20 hover:bg-white/30 backdrop-blur-md rounded-lg text-white text-sm transition-all" data-id="element-9564">
              Add More
            </button>
          </div>
        </div>
      </div>

      {/* Upgrade Success Message */}
      {showUpgradeSuccess && <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-9565">
          <div className="bg-white dark:bg-gray-900 rounded-xl p-6 shadow-2xl max-w-md w-full mx-4 animate-in zoom-in-95 duration-300" data-id="element-9566">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gradient-to-r from-purple-600 to-pink-600 rounded-full" data-id="element-9567">
              <Check size={32} className="text-white" data-id="element-9568" />
            </div>
            <h3 className="text-xl font-bold text-center mb-2 dark:text-white" data-id="element-9569">
              Congratulations!
            </h3>
            <p className="text-center text-gray-600 dark:text-gray-300 mb-4" data-id="element-9570">
              You've successfully upgraded to{' '}
              {selectedTier.charAt(0).toUpperCase() + selectedTier.slice(1)}{' '}
              Membership!
            </p>
            <div className="bg-purple-50 dark:bg-purple-900/30 p-3 rounded-lg mb-4" data-id="element-9571">
              <p className="text-center text-purple-700 dark:text-purple-300 text-sm" data-id="element-9572">
                Your new benefits are now active. Enjoy your enhanced
                experience!
              </p>
            </div>
            <button className="w-full py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-medium" onClick={() => setShowUpgradeSuccess(false)} data-id="element-9573">
              Start Exploring
            </button>
          </div>
        </div>}

      {/* Flash Upgrade Offer */}
      {showFlashOffer && <div className="relative overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl p-4 mb-6 animate-pulse-subtle" data-id="element-9574">
          <div className="absolute top-0 right-0 w-20 h-20 bg-yellow-400 rotate-45 translate-x-8 -translate-y-8" data-id="element-9575"></div>
          <div className="flex items-center justify-between relative z-10" data-id="element-9576">
            <div data-id="element-9577">
              <div className="flex items-center gap-2 mb-1" data-id="element-9578">
                <Zap size={18} className="text-yellow-300" data-id="element-9579" />
                <h3 className="font-bold text-white" data-id="element-9580">Flash Upgrade Offer!</h3>
              </div>
              <p className="text-white/90 text-sm" data-id="element-9581">
                Upgrade to Gold within 48h and get{' '}
                <span className="font-bold" data-id="element-9582">+200 Gems FREE!</span>
              </p>
            </div>
            <div className="text-white text-center" data-id="element-9583">
              <div className="font-mono font-bold" data-id="element-9584">
                {String(countdown.hours).padStart(2, '0')}:
                {String(countdown.minutes).padStart(2, '0')}:
                {String(countdown.seconds).padStart(2, '0')}
              </div>
              <button className="mt-1 px-3 py-1.5 bg-white text-blue-600 rounded-lg text-sm font-medium hover:bg-yellow-100 transition-colors" onClick={() => handleUpgrade('gold')} data-id="element-9585">
                Claim Now
              </button>
            </div>
          </div>
        </div>}

      {/* Tier Selection */}
      <div className="mb-8" data-id="element-9586">
        <h2 className="text-xl font-bold mb-4 dark:text-white" data-id="element-9587">
          Membership Tiers
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-9588">
          {/* Free Tier */}
          <div className={`relative overflow-hidden rounded-xl border ${selectedTier === 'free' ? 'border-gray-300 dark:border-gray-700' : 'border-gray-200 dark:border-gray-800'} bg-white dark:bg-gray-900 p-4 transition-all`} data-id="element-9589">
            <div className="absolute inset-x-0 top-0 h-1 bg-gray-200 dark:bg-gray-700" data-id="element-9590"></div>
            <div className="flex items-center gap-2 mb-3" data-id="element-9591">
              <div className="w-10 h-10 flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full" data-id="element-9592">
                <Users size={20} className="text-gray-500 dark:text-gray-400" data-id="element-9593" />
              </div>
              <div data-id="element-9594">
                <h3 className="font-bold dark:text-white" data-id="element-9595">Free</h3>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9596">
                  Basic Access
                </p>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3 mb-3" data-id="element-9597">
              <div className="text-center" data-id="element-9598">
                <span className="text-xl font-bold dark:text-white" data-id="element-9599">$0</span>
                <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-9600">
                  /month
                </span>
              </div>
            </div>
            <ul className="space-y-2 mb-4 min-h-[180px]" data-id="element-9601">
              <li className="flex items-start gap-2" data-id="element-9602">
                <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-9603" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9604">
                  Browse Angels & feeds
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9605">
                <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-9606" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9607">
                  Limited gifts (3/day)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9608">
                <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-9609" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9610">
                  Ad-supported experience
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9611">
                <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-9612" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9613">
                  Chat requires tokens (pay-per-message)
                </span>
              </li>
            </ul>
            <button className="w-full py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 rounded-lg text-gray-600 dark:text-gray-300 font-medium transition-colors" data-id="element-9614">
              Current Plan
            </button>
          </div>

          {/* Silver Tier */}
          <div className={`relative overflow-hidden rounded-xl border ${selectedTier === 'silver' ? 'border-blue-300 dark:border-blue-700 ring-1 ring-blue-500' : 'border-gray-200 dark:border-gray-800'} bg-white dark:bg-gray-900 p-4 transition-all`} data-id="element-9615">
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-400 to-blue-500" data-id="element-9616"></div>
            {selectedTier === 'silver' && <div className="absolute top-3 right-3 px-2 py-0.5 bg-blue-100 dark:bg-blue-900 rounded-full text-xs text-blue-600 dark:text-blue-300" data-id="element-9617">
                Current
              </div>}
            <div className="flex items-center gap-2 mb-3" data-id="element-9618">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-100 dark:bg-blue-900/30 rounded-full" data-id="element-9619">
                <Award size={20} className="text-blue-500 dark:text-blue-400" data-id="element-9620" />
              </div>
              <div data-id="element-9621">
                <h3 className="font-bold dark:text-white" data-id="element-9622">Silver</h3>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9623">
                  Enhanced Experience
                </p>
              </div>
            </div>
            <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3 mb-3" data-id="element-9624">
              <div className="text-center" data-id="element-9625">
                <span className="text-xl font-bold text-blue-600 dark:text-blue-400" data-id="element-9626">
                  $9.99
                </span>
                <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-9627">
                  /month
                </span>
              </div>
            </div>
            <ul className="space-y-2 mb-4 min-h-[180px]" data-id="element-9628">
              <li className="flex items-start gap-2" data-id="element-9629">
                <Check size={16} className="text-blue-500 dark:text-blue-400 mt-0.5" data-id="element-9630" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9631">
                  Unlimited free chat with Angels
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9632">
                <Check size={16} className="text-blue-500 dark:text-blue-400 mt-0.5" data-id="element-9633" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9634">
                  Ad-free experience
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9635">
                <Check size={16} className="text-blue-500 dark:text-blue-400 mt-0.5" data-id="element-9636" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9637">
                  +100 DesireGems monthly
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9638">
                <Check size={16} className="text-blue-500 dark:text-blue-400 mt-0.5" data-id="element-9639" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9640">
                  Access to Daily Spin Wheel
                </span>
              </li>
            </ul>
            <button className={`w-full py-2 ${selectedTier === 'silver' ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 text-white'} rounded-lg font-medium transition-colors`} onClick={() => handleUpgrade('silver')} data-id="element-9641">
              {selectedTier === 'silver' ? 'Current Plan' : 'Upgrade Now'}
            </button>
          </div>

          {/* Gold Tier */}
          <div className={`relative overflow-hidden rounded-xl border ${selectedTier === 'gold' ? 'border-yellow-300 dark:border-yellow-700 ring-1 ring-yellow-500' : 'border-gray-200 dark:border-gray-800'} bg-white dark:bg-gray-900 p-4 transition-all`} data-id="element-9642">
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-yellow-400 to-yellow-500" data-id="element-9643"></div>
            <div className="absolute top-3 right-3 px-2 py-0.5 bg-yellow-100 dark:bg-yellow-900 rounded-full text-xs text-yellow-600 dark:text-yellow-300" data-id="element-9644">
              Popular
            </div>
            <div className="flex items-center gap-2 mb-3" data-id="element-9645">
              <div className="w-10 h-10 flex items-center justify-center bg-yellow-100 dark:bg-yellow-900/30 rounded-full" data-id="element-9646">
                <Crown size={20} className="text-yellow-500 dark:text-yellow-400" data-id="element-9647" />
              </div>
              <div data-id="element-9648">
                <h3 className="font-bold dark:text-white" data-id="element-9649">Gold</h3>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9650">
                  Premium Access
                </p>
              </div>
            </div>
            <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-3 mb-3" data-id="element-9651">
              <div className="text-center" data-id="element-9652">
                <span className="text-xl font-bold text-yellow-600 dark:text-yellow-400" data-id="element-9653">
                  $24.99
                </span>
                <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-9654">
                  /month
                </span>
              </div>
            </div>
            <ul className="space-y-2 mb-4 min-h-[180px]" data-id="element-9655">
              <li className="flex items-start gap-2" data-id="element-9656">
                <Check size={16} className="text-yellow-500 dark:text-yellow-400 mt-0.5" data-id="element-9657" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9658">
                  All Silver benefits
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9659">
                <Check size={16} className="text-yellow-500 dark:text-yellow-400 mt-0.5" data-id="element-9660" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9661">
                  Exclusive Angel Skins
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9662">
                <Check size={16} className="text-yellow-500 dark:text-yellow-400 mt-0.5" data-id="element-9663" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9664">
                  Premium polls & feed boosts
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9665">
                <Check size={16} className="text-yellow-500 dark:text-yellow-400 mt-0.5" data-id="element-9666" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9667">
                  Double rewards on Daily Spin
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9668">
                <Check size={16} className="text-yellow-500 dark:text-yellow-400 mt-0.5" data-id="element-9669" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9670">
                  Priority in Angel interactions
                </span>
              </li>
            </ul>
            <button className={`w-full py-2 ${selectedTier === 'gold' ? 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 dark:text-yellow-400' : 'bg-yellow-500 hover:bg-yellow-600 dark:bg-yellow-600 dark:hover:bg-yellow-700 text-white'} rounded-lg font-medium transition-colors`} onClick={() => handleUpgrade('gold')} data-id="element-9671">
              {selectedTier === 'gold' ? 'Current Plan' : 'Upgrade Now'}
            </button>
          </div>

          {/* Platinum Tier */}
          <div className={`relative overflow-hidden rounded-xl border ${selectedTier === 'platinum' ? 'border-purple-300 dark:border-purple-700 ring-1 ring-purple-500' : 'border-gray-200 dark:border-gray-800'} bg-white dark:bg-gray-900 p-4 transition-all`} data-id="element-9672">
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-purple-400 to-pink-500" data-id="element-9673"></div>
            <div className="absolute top-3 right-3 px-2 py-0.5 bg-purple-100 dark:bg-purple-900 rounded-full text-xs text-purple-600 dark:text-purple-300" data-id="element-9674">
              Exclusive
            </div>
            <div className="flex items-center gap-2 mb-3" data-id="element-9675">
              <div className="w-10 h-10 flex items-center justify-center bg-purple-100 dark:bg-purple-900/30 rounded-full" data-id="element-9676">
                <Diamond size={20} className="text-purple-500 dark:text-purple-400" data-id="element-9677" />
              </div>
              <div data-id="element-9678">
                <h3 className="font-bold dark:text-white" data-id="element-9679">Platinum</h3>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9680">
                  Ultimate Experience
                </p>
              </div>
            </div>
            <div className="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-3 mb-3" data-id="element-9681">
              <div className="text-center" data-id="element-9682">
                <span className="text-xl font-bold text-purple-600 dark:text-purple-400" data-id="element-9683">
                  $49.99
                </span>
                <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-9684">
                  /month
                </span>
              </div>
            </div>
            <ul className="space-y-2 mb-4 min-h-[180px]" data-id="element-9685">
              <li className="flex items-start gap-2" data-id="element-9686">
                <Check size={16} className="text-purple-500 dark:text-purple-400 mt-0.5" data-id="element-9687" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9688">
                  All Gold benefits
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9689">
                <Check size={16} className="text-purple-500 dark:text-purple-400 mt-0.5" data-id="element-9690" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9691">
                  Monthly Mystery Loot Box
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9692">
                <Check size={16} className="text-purple-500 dark:text-purple-400 mt-0.5" data-id="element-9693" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9694">
                  Personalized AI Angel interactions
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9695">
                <Check size={16} className="text-purple-500 dark:text-purple-400 mt-0.5" data-id="element-9696" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9697">
                  Platinum badge in feeds & chat
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-9698">
                <Check size={16} className="text-purple-500 dark:text-purple-400 mt-0.5" data-id="element-9699" />
                <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9700">
                  Invite-only access to exclusive events
                </span>
              </li>
            </ul>
            <button className={`w-full py-2 ${selectedTier === 'platinum' ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400' : 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white'} rounded-lg font-medium transition-colors`} onClick={() => handleUpgrade('platinum')} data-id="element-9701">
              {selectedTier === 'platinum' ? 'Current Plan' : 'Upgrade Now'}
            </button>
          </div>
        </div>
      </div>

      {/* Gamification Elements */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-9702">
        {/* Enhanced Spin Wheel */}
        <div className="relative overflow-hidden rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4" data-id="element-9703">
          <div className="flex items-center gap-2 mb-4" data-id="element-9704">
            <div className="w-10 h-10 flex items-center justify-center bg-pink-100 dark:bg-pink-900/30 rounded-full" data-id="element-9705">
              <RefreshCw size={20} className="text-pink-500 dark:text-pink-400" data-id="element-9706" />
            </div>
            <div data-id="element-9707">
              <h3 className="font-bold dark:text-white" data-id="element-9708">Fortune Wheel</h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9709">
                Spin daily for amazing rewards (Silver+ only)
              </p>
            </div>
          </div>
          <div className="relative h-48 flex items-center justify-center mb-4" data-id="element-9710">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXJFcbgwSeXsSaQYxjo4wA/2.jpg" alt="Wheel Hostess" className="h-full object-cover object-top rounded-lg opacity-50" data-id="element-9711" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-9712"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-9713">
              <div className="w-20 h-20 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 rounded-full flex items-center justify-center animate-pulse-slow" data-id="element-9714">
                <div className="w-16 h-16 bg-white/90 dark:bg-gray-900/90 rounded-full flex items-center justify-center" data-id="element-9715">
                  <Gift size={24} className="text-pink-500" data-id="element-9716" />
                </div>
              </div>
              <p className="mt-3 text-white text-center max-w-[200px] text-sm" data-id="element-9717">
                Spin the wheel to win tokens, gems, and exclusive angel skins!
              </p>
            </div>
          </div>
          <button className="w-full py-2.5 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white rounded-lg font-medium transition-colors" onClick={handleSpinWheel} data-id="element-9718">
            Spin Now
          </button>
        </div>

        {/* Membership Quests */}
        <div className="rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4" data-id="element-9719">
          <div className="flex items-center gap-2 mb-4" data-id="element-9720">
            <div className="w-10 h-10 flex items-center justify-center bg-green-100 dark:bg-green-900/30 rounded-full" data-id="element-9721">
              <Award size={20} className="text-green-500 dark:text-green-400" data-id="element-9722" />
            </div>
            <div data-id="element-9723">
              <h3 className="font-bold dark:text-white" data-id="element-9724">Membership Quests</h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9725">
                Complete quests to earn rewards
              </p>
            </div>
          </div>
          <div className="space-y-3 mb-4" data-id="element-9726">
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3" data-id="element-9727">
              <div className="flex items-center justify-between mb-2" data-id="element-9728">
                <div className="flex items-center gap-2" data-id="element-9729">
                  <Gift size={16} className="text-pink-500 dark:text-pink-400" data-id="element-9730" />
                  <span className="text-sm font-medium dark:text-white" data-id="element-9731">
                    Send 5 gifts this week
                  </span>
                </div>
                <span className="text-xs text-pink-500 dark:text-pink-400 font-medium" data-id="element-9732">
                  +50 💎
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mb-1.5" data-id="element-9733">
                <span data-id="element-9734">Progress</span>
                <span data-id="element-9735">2/5</span>
              </div>
              <div className="h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-9736">
                <div className="h-full bg-pink-500 dark:bg-pink-400 w-2/5 rounded-full" data-id="element-9737"></div>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3" data-id="element-9738">
              <div className="flex items-center justify-between mb-2" data-id="element-9739">
                <div className="flex items-center gap-2" data-id="element-9740">
                  <MessageCircle size={16} className="text-blue-500 dark:text-blue-400" data-id="element-9741" />
                  <span className="text-sm font-medium dark:text-white" data-id="element-9742">
                    Chat with 3 different Angels
                  </span>
                </div>
                <span className="text-xs text-blue-500 dark:text-blue-400 font-medium" data-id="element-9743">
                  +100 💗
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mb-1.5" data-id="element-9744">
                <span data-id="element-9745">Progress</span>
                <span data-id="element-9746">1/3</span>
              </div>
              <div className="h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-9747">
                <div className="h-full bg-blue-500 dark:bg-blue-400 w-1/3 rounded-full" data-id="element-9748"></div>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3" data-id="element-9749">
              <div className="flex items-center justify-between mb-2" data-id="element-9750">
                <div className="flex items-center gap-2" data-id="element-9751">
                  <Calendar size={16} className="text-purple-500 dark:text-purple-400" data-id="element-9752" />
                  <span className="text-sm font-medium dark:text-white" data-id="element-9753">
                    Login for 7 consecutive days
                  </span>
                </div>
                <span className="text-xs text-purple-500 dark:text-purple-400 font-medium" data-id="element-9754">
                  Angel Skin
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mb-1.5" data-id="element-9755">
                <span data-id="element-9756">Progress</span>
                <span data-id="element-9757">5/7</span>
              </div>
              <div className="h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-9758">
                <div className="h-full bg-purple-500 dark:bg-purple-400 w-[71%] rounded-full" data-id="element-9759"></div>
              </div>
            </div>
          </div>
          <button className="w-full py-2.5 bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 text-white rounded-lg font-medium transition-colors" data-id="element-9760">
            View All Quests
          </button>
        </div>
      </div>

      {/* Visual Rewards & Referrals */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-9761">
        {/* Visual Rewards */}
        <div className="rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4" data-id="element-9762">
          <div className="flex items-center gap-2 mb-4" data-id="element-9763">
            <div className="w-10 h-10 flex items-center justify-center bg-indigo-100 dark:bg-indigo-900/30 rounded-full" data-id="element-9764">
              <Shield size={20} className="text-indigo-500 dark:text-indigo-400" data-id="element-9765" />
            </div>
            <div data-id="element-9766">
              <h3 className="font-bold dark:text-white" data-id="element-9767">Collectible Rewards</h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9768">
                Show off your status
              </p>
            </div>
          </div>
          <div className="bg-indigo-50 dark:bg-indigo-900/20 rounded-lg p-4 mb-4" data-id="element-9769">
            <h4 className="font-medium text-sm mb-3 dark:text-white" data-id="element-9770">
              Tier Badges
            </h4>
            <div className="flex justify-between items-center" data-id="element-9771">
              <div className="flex flex-col items-center" data-id="element-9772">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full mb-1" data-id="element-9773">
                  <Users size={20} className="text-gray-500 dark:text-gray-400" data-id="element-9774" />
                </div>
                <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9775">
                  Free
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-9776">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 dark:bg-blue-900/30 rounded-full mb-1" data-id="element-9777">
                  <Award size={20} className="text-blue-500 dark:text-blue-400" data-id="element-9778" />
                </div>
                <span className="text-xs text-blue-500 dark:text-blue-400" data-id="element-9779">
                  Silver
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-9780">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full mb-1 relative" data-id="element-9781">
                  <Crown size={20} className="text-gray-400 dark:text-gray-500" data-id="element-9782" />
                  <Lock size={12} className="absolute bottom-0 right-0 text-gray-500 dark:text-gray-400" data-id="element-9783" />
                </div>
                <span className="text-xs text-gray-400 dark:text-gray-500" data-id="element-9784">
                  Gold
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-9785">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full mb-1 relative" data-id="element-9786">
                  <Diamond size={20} className="text-gray-400 dark:text-gray-500" data-id="element-9787" />
                  <Lock size={12} className="absolute bottom-0 right-0 text-gray-500 dark:text-gray-400" data-id="element-9788" />
                </div>
                <span className="text-xs text-gray-400 dark:text-gray-500" data-id="element-9789">
                  Platinum
                </span>
              </div>
            </div>
          </div>
          <div className="bg-indigo-50 dark:bg-indigo-900/20 rounded-lg p-4" data-id="element-9790">
            <div className="flex items-center justify-between mb-3" data-id="element-9791">
              <h4 className="font-medium text-sm dark:text-white" data-id="element-9792">
                Streak Rewards
              </h4>
              <div className="text-xs px-1.5 py-0.5 bg-indigo-100 dark:bg-indigo-900/50 rounded-full text-indigo-600 dark:text-indigo-300" data-id="element-9793">
                2/3 months
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-9794">
              <div className="w-16 h-16 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg flex items-center justify-center" data-id="element-9795">
                <Sparkles size={24} className="text-indigo-500 dark:text-indigo-400" data-id="element-9796" />
              </div>
              <div data-id="element-9797">
                <p className="text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-9798">
                  Renew for 3 months straight to unlock a limited edition Angel
                  Skin!
                </p>
                <div className="h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-9799">
                  <div className="h-full bg-indigo-500 dark:bg-indigo-400 w-2/3 rounded-full" data-id="element-9800"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Referrals & Upsells */}
        <div className="rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4" data-id="element-9801">
          <div className="flex items-center gap-2 mb-4" data-id="element-9802">
            <div className="w-10 h-10 flex items-center justify-center bg-yellow-100 dark:bg-yellow-900/30 rounded-full" data-id="element-9803">
              <Users size={20} className="text-yellow-500 dark:text-yellow-400" data-id="element-9804" />
            </div>
            <div data-id="element-9805">
              <h3 className="font-bold dark:text-white" data-id="element-9806">Invite & Save</h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9807">
                Refer friends and get rewards
              </p>
            </div>
          </div>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-4 mb-4" data-id="element-9808">
            <div className="flex items-center justify-between mb-3" data-id="element-9809">
              <h4 className="font-medium text-sm dark:text-white" data-id="element-9810">
                Referral Program
              </h4>
              <div className="text-xs px-1.5 py-0.5 bg-yellow-100 dark:bg-yellow-900/50 rounded-full text-yellow-600 dark:text-yellow-300" data-id="element-9811">
                New!
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-9812">
              <div className="w-12 h-12 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center" data-id="element-9813">
                <Gift size={20} className="text-yellow-500 dark:text-yellow-400" data-id="element-9814" />
              </div>
              <div data-id="element-9815">
                <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-9816">
                  Invite a friend and both of you will receive{' '}
                  <span className="font-medium text-yellow-600 dark:text-yellow-400" data-id="element-9817">
                    +50 DesireGems!
                  </span>
                </p>
              </div>
            </div>
            <button className="w-full mt-3 py-2 bg-yellow-500 hover:bg-yellow-600 dark:bg-yellow-600 dark:hover:bg-yellow-700 text-white rounded-lg text-sm font-medium transition-colors" onClick={() => {
            // Dispatch event to open the referral modal
            const referralEvent = new CustomEvent('openReferralModal', {
              detail: {
                ritualId: undefined // No specific ritual ID for this flow
              }
            });
            document.dispatchEvent(referralEvent);
          }} data-id="element-9818">
              Invite Friends
            </button>
          </div>
          <div className="bg-gradient-to-r from-pink-50 to-purple-50 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg p-4" data-id="element-9819">
            <div className="flex items-center justify-between mb-3" data-id="element-9820">
              <h4 className="font-medium text-sm dark:text-white" data-id="element-9821">
                Special Bundle
              </h4>
              <div className="text-xs px-1.5 py-0.5 bg-pink-100 dark:bg-pink-900/50 rounded-full text-pink-600 dark:text-pink-300" data-id="element-9822">
                20% OFF
              </div>
            </div>
            <div className="bg-white/60 dark:bg-gray-800/60 backdrop-blur-sm rounded-lg p-3 mb-3" data-id="element-9823">
              <div className="flex items-center gap-3" data-id="element-9824">
                <div className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full flex items-center justify-center" data-id="element-9825">
                  <Crown size={18} className="text-white" data-id="element-9826" />
                </div>
                <div className="flex-1" data-id="element-9827">
                  <p className="text-sm font-medium dark:text-white" data-id="element-9828">
                    Gold Membership
                  </p>
                  <div className="flex items-center" data-id="element-9829">
                    <span className="text-xs text-gray-500 dark:text-gray-400 line-through mr-1" data-id="element-9830">
                      $24.99
                    </span>
                    <span className="text-xs text-pink-600 dark:text-pink-400" data-id="element-9831">
                      $19.99
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/60 dark:bg-gray-800/60 backdrop-blur-sm rounded-lg p-3 mb-3" data-id="element-9832">
              <div className="flex items-center gap-3" data-id="element-9833">
                <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center" data-id="element-9834">
                  <Gem size={18} className="text-white" data-id="element-9835" />
                </div>
                <div className="flex-1" data-id="element-9836">
                  <p className="text-sm font-medium dark:text-white" data-id="element-9837">
                    500 DesireGems
                  </p>
                  <div className="flex items-center" data-id="element-9838">
                    <span className="text-xs text-gray-500 dark:text-gray-400 line-through mr-1" data-id="element-9839">
                      $49.99
                    </span>
                    <span className="text-xs text-pink-600 dark:text-pink-400" data-id="element-9840">
                      $39.99
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <button className="w-full py-2 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white rounded-lg text-sm font-medium transition-colors" data-id="element-9841">
              Get Bundle for $59.98
            </button>
          </div>
        </div>
      </div>

      {/* Mystery Loot Box Preview */}
      <div className="rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 p-0.5 mb-8" data-id="element-9842">
        <div className="bg-white dark:bg-gray-900 rounded-[0.65rem] p-4 overflow-hidden" data-id="element-9843">
          <div className="flex items-center justify-between mb-4" data-id="element-9844">
            <div className="flex items-center gap-2" data-id="element-9845">
              <div className="w-10 h-10 flex items-center justify-center bg-purple-100 dark:bg-purple-900/30 rounded-full" data-id="element-9846">
                <Package size={20} className="text-purple-500 dark:text-purple-400" data-id="element-9847" />
              </div>
              <div data-id="element-9848">
                <h3 className="font-bold dark:text-white" data-id="element-9849">Mystery Loot Box</h3>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9850">
                  Platinum exclusive reward
                </p>
              </div>
            </div>
            <div className="text-xs px-2 py-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white" data-id="element-9851">
              Platinum Only
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" data-id="element-9852">
            <div className="sm:col-span-1 flex justify-center" data-id="element-9853">
              <div className="relative w-32 h-32" data-id="element-9854">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 rounded-lg animate-pulse-slow opacity-50 blur-md" data-id="element-9855"></div>
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-9856">
                  <div className="w-24 h-24 bg-white dark:bg-gray-800 rounded-lg shadow-lg flex items-center justify-center" data-id="element-9857">
                    <Package size={32} className="text-purple-500 dark:text-purple-400" data-id="element-9858" />
                  </div>
                </div>
              </div>
            </div>
            <div className="sm:col-span-2 flex flex-col justify-center" data-id="element-9859">
              <h4 className="font-medium mb-2 dark:text-white" data-id="element-9860">
                Monthly Surprise Box
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-9861">
                Each month, Platinum members receive an exclusive Mystery Loot
                Box containing premium rewards:
              </p>
              <ul className="space-y-1" data-id="element-9862">
                <li className="flex items-center gap-2" data-id="element-9863">
                  <div className="w-5 h-5 flex items-center justify-center bg-pink-100 dark:bg-pink-900/30 rounded-full" data-id="element-9864">
                    <Check size={12} className="text-pink-500 dark:text-pink-400" data-id="element-9865" />
                  </div>
                  <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9866">
                    Exclusive Angel Skins
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-9867">
                  <div className="w-5 h-5 flex items-center justify-center bg-pink-100 dark:bg-pink-900/30 rounded-full" data-id="element-9868">
                    <Check size={12} className="text-pink-500 dark:text-pink-400" data-id="element-9869" />
                  </div>
                  <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9870">
                    Premium DesireGems bundles
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-9871">
                  <div className="w-5 h-5 flex items-center justify-center bg-pink-100 dark:bg-pink-900/30 rounded-full" data-id="element-9872">
                    <Check size={12} className="text-pink-500 dark:text-pink-400" data-id="element-9873" />
                  </div>
                  <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9874">
                    Limited-time interaction boosts
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-9875">
                  <div className="w-5 h-5 flex items-center justify-center bg-pink-100 dark:bg-pink-900/30 rounded-full" data-id="element-9876">
                    <Check size={12} className="text-pink-500 dark:text-pink-400" data-id="element-9877" />
                  </div>
                  <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-9878">
                    Surprise collectibles and more!
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <button className="w-full py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-purple-700 text-white rounded-lg font-medium transition-colors" onClick={() => handleUpgrade('platinum')} data-id="element-9879">
            Upgrade to Platinum to Unlock
          </button>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4 mb-6" data-id="element-9880">
        <div className="flex items-center gap-2 mb-4" data-id="element-9881">
          <div className="w-10 h-10 flex items-center justify-center bg-blue-100 dark:bg-blue-900/30 rounded-full" data-id="element-9882">
            <HelpCircle size={20} className="text-blue-500 dark:text-blue-400" data-id="element-9883" />
          </div>
          <div data-id="element-9884">
            <h3 className="font-bold dark:text-white" data-id="element-9885">
              Frequently Asked Questions
            </h3>
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9886">
              Common questions about memberships
            </p>
          </div>
        </div>
        <div className="space-y-3" data-id="element-9887">
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3" data-id="element-9888">
            <h4 className="font-medium text-sm mb-1 dark:text-white" data-id="element-9889">
              How do I cancel my subscription?
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-300" data-id="element-9890">
              You can cancel your subscription at any time from the Membership
              settings. Your benefits will remain active until the end of your
              billing period.
            </p>
          </div>
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3" data-id="element-9891">
            <h4 className="font-medium text-sm mb-1 dark:text-white" data-id="element-9892">
              When do I receive my monthly DesireGems?
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-300" data-id="element-9893">
              Your monthly DesireGems are credited to your account on your
              billing date. Silver members receive 100 gems, Gold members
              receive 250 gems, and Platinum members receive 500 gems.
            </p>
          </div>
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3" data-id="element-9894">
            <h4 className="font-medium text-sm mb-1 dark:text-white" data-id="element-9895">
              Can I upgrade my membership mid-cycle?
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-300" data-id="element-9896">
              Yes! You can upgrade at any time. You'll be charged the prorated
              difference for the remainder of your current billing cycle, and
              your new benefits will be available immediately.
            </p>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4 mb-8" data-id="element-9897">
        <div className="flex items-center justify-between mb-4" data-id="element-9898">
          <div className="flex items-center gap-2" data-id="element-9899">
            <div className="w-10 h-10 flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full" data-id="element-9900">
              <CreditCard size={20} className="text-gray-500 dark:text-gray-400" data-id="element-9901" />
            </div>
            <div data-id="element-9902">
              <h3 className="font-bold dark:text-white" data-id="element-9903">Payment Methods</h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9904">
                Manage your payment options
              </p>
            </div>
          </div>
          <button className="text-sm text-blue-500 dark:text-blue-400" data-id="element-9905">
            Add New
          </button>
        </div>
        <div className="space-y-3" data-id="element-9906">
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3 flex items-center justify-between" data-id="element-9907">
            <div className="flex items-center gap-3" data-id="element-9908">
              <div className="w-10 h-6 bg-blue-600 rounded flex items-center justify-center" data-id="element-9909">
                <span className="text-white text-xs font-bold" data-id="element-9910">VISA</span>
              </div>
              <div data-id="element-9911">
                <p className="text-sm font-medium dark:text-white" data-id="element-9912">
                  Visa ending in 4242
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9913">
                  Expires 05/2025
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-9914">
              <div className="px-2 py-0.5 bg-green-100 dark:bg-green-900/30 rounded-full text-xs text-green-600 dark:text-green-400" data-id="element-9915">
                Default
              </div>
              <button className="p-1.5 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full" data-id="element-9916">
                <ChevronRight size={16} className="text-gray-400" data-id="element-9917" />
              </button>
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3 flex items-center justify-between" data-id="element-9918">
            <div className="flex items-center gap-3" data-id="element-9919">
              <div className="w-10 h-6 bg-gradient-to-r from-orange-500 to-red-500 rounded flex items-center justify-center" data-id="element-9920">
                <span className="text-white text-xs font-bold" data-id="element-9921">MC</span>
              </div>
              <div data-id="element-9922">
                <p className="text-sm font-medium dark:text-white" data-id="element-9923">
                  Mastercard ending in 5678
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9924">
                  Expires 09/2024
                </p>
              </div>
            </div>
            <button className="p-1.5 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full" data-id="element-9925">
              <ChevronRight size={16} className="text-gray-400" data-id="element-9926" />
            </button>
          </div>
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 p-0.5 mb-6" data-id="element-9927">
        <div className="bg-white dark:bg-gray-900 rounded-[0.65rem] p-6 text-center" data-id="element-9928">
          <h3 className="text-xl font-bold mb-2 dark:text-white" data-id="element-9929">
            Ready to enhance your experience?
          </h3>
          <p className="text-gray-600 dark:text-gray-300 mb-4 max-w-md mx-auto" data-id="element-9930">
            Upgrade your membership today and unlock premium features, exclusive
            content, and special rewards!
          </p>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-9931">
            <button className="px-4 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg font-medium transition-colors" onClick={() => handleUpgrade('silver')} data-id="element-9932">
              Silver $9.99/mo
            </button>
            <button className="px-4 py-2.5 bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white rounded-lg font-medium transition-colors" onClick={() => handleUpgrade('gold')} data-id="element-9933">
              Gold $24.99/mo
            </button>
            <button className="px-4 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-lg font-medium transition-colors" onClick={() => handleUpgrade('platinum')} data-id="element-9934">
              Platinum $49.99/mo
            </button>
          </div>
        </div>
      </div>

      {/* Enhanced Spin Wheel Modal */}
      {showSpinWheel && <EnhancedSpinWheel isOpen={showSpinWheel} onClose={handleCloseSpinWheel} onRewardClaimed={handleRewardClaimed} userTokens={userTokens} data-id="element-9935" />}

      {/* ... existing styles ... */}
    </div>;
};